import createCachedSelector from "re-reselect";
import { CombineKeys } from "utils/functions";

const emptyArray = [];
const defaultIncomeTypes = {
  isLoaded: false,
  loading: {}
};

const defaultIncomeData = {
  isLoaded: false,
  isValid: false,
  saving: false
};

export const getOfferPartnerIncomeTypes = (state, partnerId) => {
  const partnerIncomeTypesData = state.entities.offerPartnerIncomeTypes[partnerId];
  return partnerIncomeTypesData ? partnerIncomeTypesData.incomes : emptyArray;
};

const getIncomeTypesData = (state, partnerId) =>
  state.currentOffer.clientIncomeTypesData.incomeTypes[partnerId] || defaultIncomeTypes;

export const getIncomeTypesIsLoaded = createCachedSelector(getIncomeTypesData, incomeTypesData => {
  return incomeTypesData.isLoaded;
})((_, partnerId) => partnerId);

export const getIncomeTypesLoading = (state, partnerId) => {
  const incomeTypesData = getIncomeTypesData(state, partnerId);
  return incomeTypesData.loading;
};

const getPartnerIncomeData = (state, partnerId, incomeTypeId) => {
  const key = CombineKeys(partnerId, incomeTypeId);
  const partnerIncomeData = state.entities.offerPartnerIncomeData[key];
  return partnerIncomeData && partnerIncomeData.incomeData ? partnerIncomeData.incomeData : emptyArray;
};

const getIncomeData = (state, partnerId, incomeTypeId) =>
  state.currentOffer.clientIncomeData.incomeData[CombineKeys(partnerId, incomeTypeId)] || defaultIncomeData;

export const getIncomeDataIsLoaded = createCachedSelector(getIncomeData, incomeData => {
  return incomeData.isLoaded;
})((_, partnerId) => partnerId);

export const getIncomeDataIsValid = createCachedSelector(getIncomeData, incomeData => {
  return incomeData.isValid;
})((_, partnerId) => partnerId);

export const getIncomeDataIsSaving = createCachedSelector(getIncomeData, incomeData => {
  return incomeData.saving;
})((_, partnerId) => partnerId);

export const getOfferPartnerIncomeData = createCachedSelector(
  getIncomeDataIsLoaded,
  getPartnerIncomeData,
  (isLoaded, incomeData) => {
    if (!isLoaded) {
      return emptyArray;
    }
    return incomeData;
  }
)((_, partnerId) => partnerId);
